export default __webpack_public_path__ + "static/media/info.b7c490bf.svg";